import React from "react";
import { Card } from "@/components/ui/card";
import { TrendUp, TrendDown, Drop, Ruler, ChartLine, GitBranch } from "@phosphor-icons/react";

const KpiCard = ({ label, value, unit, icon: Icon, tone = "primary", sub, testId }) => {
  const toneColor = {
    primary: "text-[#3EB6F0]",
    danger: "text-[#EF4444]",
    success: "text-[#10B981]",
    warning: "text-[#F59E0B]",
  }[tone];
  return (
    <Card className="bg-[#111827] border border-slate-800 rounded-lg p-5 relative overflow-hidden" data-testid={testId}>
      <div className="flex items-start justify-between mb-4">
        <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">{label}</div>
        <Icon size={18} weight="duotone" className={toneColor} />
      </div>
      <div className="flex items-baseline gap-2">
        <div className={`font-mono font-semibold text-3xl ${toneColor} kpi-value`}>{value}</div>
        <div className="text-xs text-slate-500 font-mono">{unit}</div>
      </div>
      {sub && <div className="mt-2 text-xs text-slate-400 font-mono">{sub}</div>}
    </Card>
  );
};

export default function KpiCards({ arera, alertsCount }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <KpiCard testId="kpi-m1a" label="M1a · Perdita" value={arera.m1a_pct} unit="%" icon={ChartLine}
        tone={arera.m1a_pct > 25 ? "danger" : "primary"}
        sub={`Delibera ARERA 917/2017`}
      />
      <KpiCard testId="kpi-m1b" label="M1b · Lineare" value={arera.m1b_m3_km_gg} unit="m³/km/gg" icon={Ruler}
        tone={arera.m1b_m3_km_gg > 30 ? "warning" : "primary"}
        sub="Perdita distrettuale"
      />
      <KpiCard testId="kpi-immesso" label="Immesso" value={arera.immesso_m3_gg} unit="m³/gg" icon={Drop} tone="primary"
        sub={`Fatturato ${arera.fatturato_m3_gg} m³`}
      />
      <KpiCard testId="kpi-alerts" label="Allarmi Attivi" value={alertsCount} unit="eventi" icon={GitBranch}
        tone={alertsCount > 0 ? "danger" : "success"}
        sub={alertsCount > 0 ? "Azione richiesta" : "Rete stabile"}
      />
    </div>
  );
}
